module.exports = __webpack_public_path__ + "static/media/step2.b460c8f7.svg";